<template>
  <div class="login-content">
    <div class="bg-left bg-item" style="text-align: center">
      <div class="title">
        {{ greetTime }}！<br />
        {{ $t('main_login_welcome_system') }}
      </div>
      <div style="margin-top: 24px">
        <img style="width: 640px; height: 454px" src="@/assets/login_bg.png" alt="" />
      </div>
    </div>
    <div class="bg-right bg-item">
      <div class="login-content">
        <div class="loginway-content">
          <!-- <div v-if="isHasEnv" class="toggle-icon" @click="tabLoginWay">
            <i v-if="!isQrCode" class="iconfont el-icon-qr-code"></i>
            <i v-else class="iconfont el-icon-password-pc"></i>
          </div> -->
        </div>
        <div class="logo-content">
          <img src="@/assets/gofo.svg" alt="" />
          <LanguagePicker />
        </div>
        <div
          style="flex: 1; display: flex; flex-direction: column; justify-content: center"
          v-loading="isEnvLoading"
        >
          <component v-if="isHasEnv" :is="isLogin"></component>
          <p v-if="!isHasEnv && !isEnvLoading" style="text-align: center">
            {{ $t('main_login_loading_failure') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, provide, inject } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import LanguagePicker from '@/components/Layout/LanguagePicker.vue'
import PasswordCredential from './components/PasswordCredential'
import QrCode from './components/QrCode'
import { getEnvironmentConfig, getUserMenuList, getLoginPlatform } from '@/services/user'
import { urlQueryfilter, urlQueryFeishufilter } from '@/utils/tools'

export default defineComponent({
  name: 'Login',
  components: { LanguagePicker },
  setup() {
    const $t = inject('$t')
    const router = useRouter()
    const route = useRoute()
    const isQrCode = ref(false)
    const isLogin = computed(() => {
      return isQrCode.value ? QrCode : PasswordCredential
    })
    const initGreet = () => {
      const hours = new Date().getHours()
      if (hours >= 6 && hours < 11) {
        return $t('main_login_morning_greetings')
      } else if (hours >= 11 && hours < 14) {
        return $t('main_login_noon_greetings')
      } else if (hours >= 14 && hours < 18) {
        return $t('main_login_afternoon_greetings')
      } else {
        return $t('main_login_night_greetings')
      }
    }
    const greetTime = initGreet()

    // 切换二维码显示
    const tabLoginWay = () => {
      isQrCode.value = !isQrCode.value
    }

    const isDingLogin = async () => {
      const { query } = route
      if (query.token) {
        isQrCode.value = true
      }
    }

    const store = useStore()

    const isHasEnv = ref(false)
    const isEnvLoading = ref(true)
    // const getEnv = async () => {
    //   try {
    //     const { data } = await getEnvironmentConfig()
    //     store.commit('env/setEnv', data?.EnvironmentName?.toLowerCase())
    //     store.commit('env/setEnvInfo', data || {})
    //     store.commit('baseUrl/setBaseUrl', data?.GatewayEntrypoint)

    //     isHasEnv.value = true
    //     resolve()
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     isEnvLoading.value = false
    //   }
    // }

    // getEnv().then(() => {
    //   getLoginPlatform().then(res => {
    //     store.commit('env/setAmsConfig', res?.data)
    //     // console.log(res?.data, '================')
    //   })
    // })

    const getEnv = async () => {
      try {
        const { data } = await getEnvironmentConfig()
        if (data) {
          store.commit('env/setEnv', data.EnvironmentName?.toLowerCase())
          store.commit('env/setEnvInfo', data)
          store.commit('baseUrl/setBaseUrl', data.GatewayEntrypoint)

          isHasEnv.value = true
        }
      } catch (error) {
        console.error('Failed to fetch environment config:', error)
      } finally {
        isEnvLoading.value = false
      }
    }

    const handleLoginPlatform = async res => {
      if (res && res.data) {
        store.commit('env/setAmsConfig', res.data)
      }
    }

    ;(async () => {
      try {
        await getEnv()
        // const loginPlatformRes = await getLoginPlatform()
        // await handleLoginPlatform(loginPlatformRes)
      } catch (error) {
        console.error('Failed to fetch login platform data:', error)
      }
    })()

    // const toLogin = async data => {
    //   return new Promise((resolve, reject) => {
    //     const userInfo = {
    //       name: data.info.meta.Name,
    //       uid: data.info.uid,
    //       token: data.token,
    //       expired: data.expired
    //     }

    //     // 设置 userInfo
    //     store.commit('user/setUserInfo', userInfo)

    //     gtag('config', 'G-D19FVNNRMT', {
    //       user_id: userInfo?.uid ?? ''
    //     })
    //     getLoginPlatform(data?.info?.uid).then(res => {
    //       handleLoginPlatform(res)
    //     })
    //     getUserMenuList()
    //       .then(res => {
    //         store.commit('menu/setMenuList', res.data.menuList)
    //         store.commit('menu/setPageList', res.data.pageList)
    //         let url = ''
    //         let path = ''
    //         console.log(route.query, '--route.query')

    //         if (route.query?.token && Object.keys(route.query).length > 2) {
    //           // 通过判断路径中query的参数，参数大于1个，是路径带参数跳转后飞书扫码登录
    //           console.log('带额外参数跳转，飞书扫码')
    //           url = window.location.href
    //           path = urlQueryFeishufilter(url, ['token'])
    //         } else {
    //           // 非重定向 || 重定向不带参数 || 重定向带参数且query只有redirect一个参数 || 重定向带参数且query只有token和redirect两个参数
    //           url = route.query.redirect || '/'
    //           path = urlQueryfilter(url, ['token'])
    //         }

    //         console.log(path, '--path')
    //         router.push(path)
    //         resolve()
    //       })
    //       .catch(error => {
    //         store.commit('user/setUserInfo', null)
    //         console.log(error)
    //         reject(error)
    //       })
    //   })
    // }

    const toLogin = async data => {
      try {
        const { info, token, expired } = data

        // 设置 userInfo
        const userInfo = {
          name: info.meta.Name,
          uid: info.uid,
          token,
          expired
        }

        store.commit('user/setUserInfo', userInfo)

        // 发送 Google Analytics 事件
        gtag('config', 'G-D19FVNNRMT', {
          user_id: userInfo.uid ?? ''
        })
        // if (store.state.env.amsConfig?.UserSourceSwitch) {
        // 获取并设置登录平台数据
        const loginPlatformRes = await getLoginPlatform(info.uid)
        handleLoginPlatform(loginPlatformRes)
        // }

        // 获取用户菜单列表
        const menuListRes = await getUserMenuList()
        store.commit('menu/setMenuList', menuListRes.data.menuList)
        store.commit('menu/setPageList', menuListRes.data.pageList)

        // 处理重定向路径
        let path = route.query.redirect || '/'
        if (route.query.token && Object.keys(route.query).length > 2) {
          // 带额外参数跳转，飞书扫码登录
          const url = window.location.href
          path = urlQueryFeishufilter(url, ['token'])
        } else {
          // 非重定向或重定向不带参数等情况
          path = urlQueryfilter(path, ['token'])
        }

        // 跳转到指定路径
        router.push(path)
      } catch (error) {
        // 错误处理
        store.commit('user/setUserInfo', null)
        store.commit('env/setAmsConfig', null)
        console.error('Failed to complete login process:', error)
        throw error
      }
    }

    isDingLogin()
    provide('toLogin', toLogin)

    return {
      isQrCode,
      isLogin,
      greetTime,
      isHasEnv,
      isEnvLoading,
      tabLoginWay,
      isDingLogin,
      toLogin
    }
  }
})
</script>

<style lang="scss" scoped>
.login-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  background-color: $primary-color;

  .bg-item {
    flex: 1;
  }

  .bg-left {
    background-color: #f6f5ef;

    .title {
      font-size: 45px;
      font-weight: 700;
      text-align: center;
      margin-top: 80px;
      color: $primary-color;
    }
  }

  .bg-right {
    display: flex;
    align-items: center;
    justify-content: center;

    .login-content {
      width: 380px;
      height: 470px;
      padding: 5px;
      padding-bottom: 50px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      border-radius: 5px;
      background-color: #ffffff;

      .loginway-content {
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: flex-end;

        i {
          font-size: 36px;
          cursor: pointer;
          color: #999999;

          // &.el-icon-password-pc {
          //   font-size: 32px;
          // }
        }
      }

      .logo-content {
        display: flex;
        height: 65px;
        padding: 0 35px;
        justify-content: space-between;
        align-items: flex-start;
      }
    }
  }
}
</style>
